/** 错误类型常量 */
export const ErrorType = {
  NETWORK_ERROR: 'NETWORK_ERROR',
  HTTP_ERROR: 'HTTP_ERROR',
  BUSINESS_ERROR: 'BUSINESS_ERROR',
  TIMEOUT_ERROR: 'TIMEOUT_ERROR',
  CANCEL_ERROR: 'CANCEL_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
} as const

export type ErrorType = (typeof ErrorType)[keyof typeof ErrorType]

/** 统一错误类 */
export class ApiError extends Error {
  type: ErrorType
  status: number | undefined
  code: number | string | undefined
  originalError: unknown
  data: unknown

  constructor(
    type: ErrorType,
    message: string,
    status?: number,
    code?: number | string,
    originalError?: unknown,
    data?: unknown
  ) {
    super(message)
    this.name = 'ApiError'
    this.type = type
    this.status = status
    this.code = code
    this.originalError = originalError
    this.data = data
  }

  isNetworkError(): boolean {
    return this.type === ErrorType.NETWORK_ERROR
  }

  isBusinessError(): boolean {
    return this.type === ErrorType.BUSINESS_ERROR
  }

  isAuthError(): boolean {
    return this.status === 401
  }

  isForbiddenError(): boolean {
    return this.status === 403
  }
}
